import { ComponentType, PropsWithChildren, ReactNode } from "react";
import styled from "styled-components";
import { QueryRef } from "@apollo/client";
import { zIndex } from "@songtradr-one/components-frontend";
import { UserLayoutQuery, graphql } from "@songtradr-one/shared-common";

// TEXT

// STYLES
export const IsImFrame = styled.div`
  width: 100vw;
  height: 100vh;
  z-index: ${zIndex.banner}; /* Above every modal/surface, below toast */
  position: fixed;
  pointer-events: none;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: 0;
    padding: 0.35rem;
    background: conic-gradient(
      from var(--isim-frame-angle, 0deg),
      #ff2d55,
      #ff9500,
      #ffcc00,
      #34c759,
      #00c7be,
      #30b0ff,
      #af52de,
      #ff2d55
    );
    -webkit-mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    mask-composite: exclude;
    animation: isim-frame-rotate 3s linear infinite;
  }

  /* NOTE: @property and @keyframes are global CSS declarations; prefixed to avoid collisions */
  @property --isim-frame-angle {
    syntax: "<angle>";
    initial-value: 0deg;
    inherits: false;
  }

  @keyframes isim-frame-rotate {
    to {
      --isim-frame-angle: 360deg;
    }
  }
`;

// DATA
export const UserLayout_Query = graphql(`
  query UserLayout {
    user {
      id
      email
      firstName
      lastName
      picture
      orgId
      inOrgs {
        id
        parentOrgId
        name
        workspace
      }
      permissions
      isImInfo {
        isIm
        title
        body
        disclaimer
        confirmLabel
      }
      labApps
      subscription {
        provider
        name
        isActive
        manageUrl
      }
    }
    org {
      id
      parentOrgId
      name
      workspace
      loginMethods
      metadata {
        analytics {
          heap {
            enabled
          }
        }
        assets {
          logo
          background
        }
      }
    }
  }
`);

// TYPES
export interface Props extends UserLayoutConfig, PropsWithChildren {
  queryRef: QueryRef<UserLayoutQuery, unknown>;
}

export type UserLayoutConfig = {
  header?: ReactNode;
  footer?: ReactNode;
  rebrand?: boolean;
  guard?: ComponentType<PropsWithChildren>;
};

// CONSTANTS
export const USER_LAYOUT_ID = "user-layout";

// FUNCTIONS

// ASSETS
